import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { SessionRow, SessionsProvider } from '../../providers/sessions-provider';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { SessionDatasource } from '../../../common/datasource/session.datasource';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { Organization } from "../../../common/models/organization";
import { Library } from "../../../common/models/library";
import { SessionsSessionPreviewComponent } from "../session-preview/session-preview";
import { MatIcon } from "@angular/material/icon";
import { AsyncPipe, NgForOf, NgIf } from "@angular/common";
import { MatFormField, MatSuffix } from "@angular/material/form-field";
import { TranslateModule } from "@ngx-translate/core";
import { MatInput } from "@angular/material/input";
import { CdkDragHandle, DragDropModule } from "@angular/cdk/drag-drop";
import { SimpleMatDataSource } from "../../../common/providers/simple-mat-data-source";
import { CenterLoaderComponent } from "../../../common/components/center-loader/center-loader";

@Component({
  selector: 'sessions-sessions-list-side-menu',
  providers: [],
  standalone: true,
  styleUrls: ['./sessions-list-side-menu.scss'],
  imports: [
    MatPaginator,
    SessionsSessionPreviewComponent,
    MatIcon,
    AsyncPipe,
    NgForOf,
    MatSuffix,
    TranslateModule,
    MatInput,
    MatFormField,
    DragDropModule,
    CenterLoaderComponent,
    NgIf
  ],
  templateUrl: './sessions-list-side-menu.html'
})
export class SessionsSessionListSideMenuComponent implements OnInit, AfterViewInit, OnDestroy {

    public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
    public sessionRows$: Observable<SessionRow[]> | undefined;
    public sessionDataSource: SessionDatasource = new SessionDatasource(this._sessionsProvider);
    @ViewChild('searchSession', {static: false}) public input: ElementRef | undefined;

    @Input() public organization: Organization = { } as Organization;
    @Input() public library: Library = { } as Library;

    public readonly itemsPerPage = 10;
    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | null = null;

    public isLoading: boolean = true;

    private searchSubscription: Subscription | undefined;
    private paginatorSubscription: Subscription | undefined;

    constructor(
        private _sessionsProvider: SessionsProvider,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    public ngOnInit(): void {
        this.sessionDataSource = new SessionDatasource(this._sessionsProvider);
        this.sessionRows$ = this.dataSource.connect();
        this.loadSessionPaginated();
    }

    public ngAfterViewInit() {
      this.searchSubscription = fromEvent<KeyboardEvent>(this.input?.nativeElement, 'keyup')
        .pipe(
          debounceTime(150),
          filter((e: KeyboardEvent) => e.key === 'Enter'),
          distinctUntilChanged()
        )
        .subscribe({
          next: () => {
            this.paginator?.firstPage();
            this.loadSessionPaginated();
          }
        });

      this.paginatorSubscription = this.paginator?.page.subscribe(() => this.loadSessionPaginated());
    }

    private loadSessionPaginated(): void {
      this.isLoading = true;

      const loadObservable$ = this.sessionDataSource.loadSessionRows(
        this.library.id!,
        this.organization,
        (this.paginator?.pageIndex ?? 0) + 1,
        this.itemsPerPage,
        this.input?.nativeElement.value
      );

      loadObservable$.subscribe({
        next: () => {
          this.isLoading = false;
          this.updateTableData();
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error("sessions/components/sessions-list-side-menu", err);
          this.changeDetectorRef.detectChanges();
        }
      });
    }

    public ngOnDestroy(): void {
      this.searchSubscription?.unsubscribe();
      this.paginatorSubscription?.unsubscribe();
    }

    private updateTableData(): void {
      this.dataSource.data = this.sessionDataSource.subject.getValue();
      this.dataSource._updateChangeSubscription();
      this.changeDetectorRef.detectChanges();
    }
}

